import { Col, Row, Skeleton } from 'antd';
import Layout from 'components/Layout';
import withGuard from 'components/withGuard';
import useFetchedData from 'hooks/useFetchedData';
import React, { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { EventEmitter } from 'utils/event';
import RunWorkflowDrawer from '../RunSequenceDrawer';
import Activities from './Activities';
import Contacts from './Contacts';
import CustomFields from './CustomFields';
import Details from './Details';
import Header from './Header';
import Tasks from './Tasks';
import './index.css';

function CompanyInfo() {
  const { id } = useParams();
  const [sequenceRunnerOpen, setSequenceRunnerOpen] = useState(null);
  const navigate = useNavigate();
  const {
    data: company = {}, error, loading, mutate: mutateCompany,
  } = useFetchedData(
    `v1/organizations/{{organizationId}}/companies/${id}/`,
  );

  const activitiesContainerRef = useRef(null);

  if (error?.response?.status === 404) {
    return navigate('/console/companies');
  }
  return (
    <>
      <Layout overflowX="visible">
        <Header id={id} />
        <Row className="w-full h-[calc(100vh-120px)] overflow-y-hidden" gutter={[0, 24]}>
          <Col
            span={24}
            lg={8}
            className="h-full overflow-y-auto"
          >
            <div className="pb-2" style={{ top: 80 }}>
              {loading && (
                <Skeleton />
              )}
              {!loading && (
                <Details company={company} fetchCompany={mutateCompany} />
              )}
              <div className="pt-2">
                <Tasks companyId={id} />
                <Contacts />
                {(company?.integration_meta && company?.integration_meta?.custom_fields) && (
                  <CustomFields meta={company?.integration_meta} />
                )}
              </div>
            </div>

          </Col>
          <Col
            span={24}
            lg={16}
            ref={activitiesContainerRef}
            className="lg:pl-5 h-full overflow-y-auto"
          >
            <Activities
              created_at={company?.created_at}
              onRunWorkflow={setSequenceRunnerOpen}
              container={activitiesContainerRef}
            />
          </Col>
        </Row>
      </Layout>
      <RunWorkflowDrawer
        open={sequenceRunnerOpen}
        onClose={() => setSequenceRunnerOpen(false)}
        companyId={id}
        onFinish={() => {
          EventEmitter.emit('refresh_contacts');
        }}
      />
    </>
  );
}

export default withGuard(CompanyInfo, null, {
  redirect: true,
});
